import { MockBridge } from "@paxvpn-cabinet/domain";
import { hasTelegramRuntime, TelegramBridge } from "@paxvpn-cabinet/platform-telegram";
import { createCabinetApp } from "@paxvpn-cabinet/ui";
import "@paxvpn-cabinet/ui/styles.css";

const root = document.querySelector<HTMLElement>("#app");

if (!root) {
  throw new Error("App root not found.");
}

const bridge = hasTelegramRuntime()
  ? new TelegramBridge("/api/cabinet")
  : new MockBridge("telegram");

createCabinetApp(root, bridge, {
  platformLabel: "Telegram Mini App",
});
